<template>
  <div class="findPassWord">
    <header-item
      :title-array="titleArray"
      :is-show="isShow"
      title-mb="密码找回"
      type-next="click"
      @navBarClick="navBarClick"
    />

    <div class="formClass">
      <!-- 密码找回第一步 -->
      <p
        v-show="$isFlag"
        style="
          color: #626fdd;
          font-size: 0.28rem;
          margin-bottom: 0.1rem;
          text-align: right;
          position: relative;
        "
        @click="forgetAccount"
      >
        忘记账号？
      </p>
      <van-form>
        <van-field
          v-model="username"
          class="field"
          label="账号名"
          placeholder="请填写您的雷霆账号"
          :rules="[{ required: true, message: '不可为空' }]"
        />
        <div>
          <div id="ltCaptchaLogin" class="entry captcha" />
          <van-checkbox
            v-model="checked"
            class="checkbox"
          >我已阅读并同意
            <span
              style="color: #626fdd"
              @click.stop="ltUserRule"
            >《雷霆游戏用户隐私政策》</span>
            <span
              style="color: #626fdd"
              @click.stop="ltGameRule"
            >《雷霆游戏用户协议》</span>
          </van-checkbox>
          <div>
            <van-button
              round
              block
              type="info"
              color="#616edf"
              class="formClass_btn"
              @click="onSubmitOne"
            >下一步</van-button>
            <p
              v-show="!$isFlag"
              style="
                color: #626fdd;
                font-size: 0.28rem;
                margin: 0.4rem 0;
                text-align: center;
                cursor: pointer;
              "
              @click="forgetAccount"
            >
              忘记账号？
            </p>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import headerItem from '@/views/accountCenter/common/header'
import sendCode from '@/mixins/sendCode'
// import ltCaptchaGraph from '@/mixins/ltCaptchaGraph'
import * as api from '@/api/account-self-manage/findPassWord'
import { ltCaptcha } from '@/utils/ltCaptcha'

export default {
  name: 'FindPassWord',
  components: {
    headerItem
  },
  mixins: [sendCode],
  data() {
    return {
      isShow: true,
      checked: false,
      username: '',
      currentIndex: 0,
      titleArray: ['密码找回', '首页', '账号自助管理', '密码找回'],
      username4: this.$route.query.name
    }
  },
  created() {},
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.findPassWord').className = ['findPassWord findPassWordH5 accountCommonH5']
    } else {
      document.querySelector('.findPassWord').className = ['findPassWord findPassWordWeb accountCommonWeb']
    }
  },
  methods: {
    forgetAccount() {
      this.$ssd.track('leiting_accountmanage_forgotAccount')
      // window.open('https://helper.leiting.com/account_retrieve/id_card.do')
      this.$router.push('/accountCenter/accountSelf/accountRetrieval')
    },
    ltGameRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff8080816f6510d4016f9e532924003e.html'
      )
    },
    ltUserRule() {
      window.open(
        'https://www.leiting.com/terrace/news/news_detail_ff80808171a5bad00171a64e53870006.html'
      )
    },
    onSubmitOne() {
      if (!this.checked) {
        this.$msg('请先勾选并同意')
        return
      }
      ltCaptcha((captcha) => {
        delete captcha.bizState
        api.user_check_aes({
          username: this.username,
          captcha
        }).then((res) => {
          if (res.status == 0) {
            this.$router.push(
              '/accountCenter/accountSelf/editPhoneNum?type=PWD_BACK'
            )
            this.$ssd.track('leiting_accountmanage_nextStep')
          }
        })
      })
    },
    navBarClick() {
      console.log('aa')
      if (this.currentIndex == 1) {
        this.currentIndex = 0
      } else {
        this.$router.go(-1)
      }
    },
    onSubmitTwo() {}
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
</style>
<style lang="stylus" scoped>
// h5
  .findPassWordH5 {
    font-size: 0.25rem;
    background: #f5f7fa;

    .sm-btn-default .shield, .sm-btn-fail .shield, .sm-btn-loading .shield, .sm-btn-success .shield {
      width: 12px;
      height: 14px;
      line-height: 38px;
      left: 12px;
      position: absolute;
      z-index: 1000;
      top: -12px !important;
    }

    .field {
      border-radius: 16px !important;
    }

    .checkbox {
      margin: 0.3rem 0;
      position relative;
            ::v-deep .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #626fdd;
    border-color: #626fdd;
}
    }

    .formClass {
      padding: 0.4rem;

      .findTwo {
        .formClass_btn {
          margin: 0.3rem 0;
        }

        span {
          font-size: 0.26rem;
        }
      }
    }
  }

// web
  .findPassWordWeb {
    border-radius: 10px;
    background: #fff;
    margin-left: 0.2rem;
    margin: 0.5rem 10%;
    font-size: 0.25rem;
    .field {
      border-radius: 5px;
    }
    .checkbox {
      margin: 0.3rem 0;
      font-size: 0.28rem;
      ::v-deep .van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #626fdd;
    border-color: #626fdd;
}
    }
    ::v-deep .van-field__body {
      // width: 8rem;
      border: 1px solid #CCCCCC;
      border-radius: 6px;
      height: 0.8rem;
      padding: 0 0.2rem;
      background: #fcfcfc;
    }
    .formClass {
      width: 40%;
      margin: auto;
      padding: 0.5rem 0;
    }
  }
</style>
